// Phase 4: Stateless verification screen component
// Extracted from Auth.tsx - lines 386-451

import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';
import type { VerificationScreenProps } from './types';

export default function VerificationScreen({
  email,
  resending,
  onResend,
  onUseDifferentEmail,
}: VerificationScreenProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4 charcoal-pro">
      <Card className="w-full max-w-md p-8 space-y-6 text-center">
        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
          <svg className="w-8 h-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        </div>
        
        <div>
          <h2 className="text-2xl font-bold mb-2">Verify Your Email</h2>
          <p className="text-muted-foreground">
            We've sent a verification link to <span className="font-medium text-foreground">{email}</span>
          </p>
          <p className="text-sm text-muted-foreground mt-2">
            After clicking the link in your email, return here and sign in. If you don't receive it, check your spam folder or try resending.
          </p>
        </div>

        {/* Helpful tip instead of timer */}
        <div className="flex items-center justify-center gap-2 py-3 px-4 bg-muted/50 rounded-lg">
          <svg className="w-4 h-4 text-muted-foreground" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="text-sm text-muted-foreground">
            Check your spam folder if you don't see the email
          </span>
        </div>
        
        <div className="space-y-3 pt-4">
          <Button 
            onClick={onResend}
            variant="outline"
            className="w-full"
            disabled={resending}
          >
            {resending ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Sending...
              </>
            ) : (
              'Resend Verification Email'
            )}
          </Button>
          
          <Button 
            onClick={onUseDifferentEmail}
            variant="ghost"
            className="w-full"
          >
            ← Back to Sign in
          </Button>
        </div>
      </Card>
    </div>
  );
}
